import {
    CalendarSection,
    DateDisplay,
    DateSelector,
    DateTextWrapper,
    NavigationButton,
    QuickButton,
    QuickButtons,
} from "../custom-styles/CalendarSection.styles";
import Text, { VARIANTS } from "shared/components/data-display/text/Text";
import {
    addDays,
    format,
    isAfter,
    isBefore,
    isSameDay,
    isToday,
    isYesterday,
    startOfDay,
    startOfISOWeek,
    subDays,
} from "date-fns";

import COLORS from "shared/config/colors";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import PropTypes from "prop-types";
import React from "react";

function CalendarSectionComponent({ selectedDate, setSelectedDate }) {
    // Get Monday of current week
    const getWeekStart = () => {
        return startOfISOWeek(new Date());
    };

    // Format date
    const formatDateDisplay = (date) => {
        return format(date, "EEEE, MMMM d, yyyy");
    };

    // Date navigation
    const goToPreviousDay = () => {
        const newDate = subDays(selectedDate, 1);
        const weekStart = getWeekStart();
        if (!isBefore(newDate, weekStart)) {
            setSelectedDate(newDate);
        }
    };

    const goToNextDay = () => {
        const newDate = addDays(selectedDate, 1);
        const today = startOfDay(new Date());
        // Only allow navigation up to today
        if (!isAfter(startOfDay(newDate), today)) {
            setSelectedDate(newDate);
        }
    };

    const goToToday = () => {
        setSelectedDate(new Date());
    };

    const goToYesterday = () => {
        const yesterday = subDays(new Date(), 1);
        const weekStart = getWeekStart();
        if (!isBefore(yesterday, weekStart)) {
            setSelectedDate(yesterday);
        }
    };

    // Check functions
    const isTodaySelected = () => {
        return isToday(selectedDate);
    };

    const isYesterdaySelected = () => {
        return isYesterday(selectedDate);
    };

    const isAtWeekStart = () => {
        const weekStart = getWeekStart();
        return isSameDay(selectedDate, weekStart);
    };

    const isYesterdayOutOfBounds = () => {
        const yesterday = subDays(new Date(), 1);
        const weekStart = getWeekStart();
        return isBefore(yesterday, weekStart);
    };

    return (
        <CalendarSection>
            <DateSelector>
                <DateDisplay>
                    <NavigationButton
                        onClick={goToPreviousDay}
                        disabled={isAtWeekStart()}
                    >
                        <ChevronLeftIcon />
                    </NavigationButton>
                    <DateTextWrapper>
                        <Text
                            variant={VARIANTS.Headline_4}
                            color={COLORS.Black}
                        >
                            {formatDateDisplay(selectedDate)}
                        </Text>
                    </DateTextWrapper>
                    <NavigationButton
                        onClick={goToNextDay}
                        disabled={isTodaySelected()}
                    >
                        <ChevronRightIcon />
                    </NavigationButton>
                </DateDisplay>
                <QuickButtons>
                    <QuickButton
                        active={isYesterdaySelected()}
                        onClick={goToYesterday}
                        disabled={isYesterdayOutOfBounds()}
                    >
                        Yesterday
                    </QuickButton>
                    <QuickButton active={isTodaySelected()} onClick={goToToday}>
                        Today
                    </QuickButton>
                </QuickButtons>
            </DateSelector>
        </CalendarSection>
    );
}

CalendarSectionComponent.propTypes = {
    selectedDate: PropTypes.instanceOf(Date),
    setSelectedDate: PropTypes.func,
};

export default CalendarSectionComponent;
